import { render, staticRenderFns } from "./UsedPartsInfoListSideMenu.vue?vue&type=template&id=a2087786&scoped=true"
import script from "./UsedPartsInfoListSideMenu.vue?vue&type=script&lang=js"
export * from "./UsedPartsInfoListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./UsedPartsInfoListSideMenu.vue?vue&type=style&index=0&id=a2087786&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2087786",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2087786')) {
      api.createRecord('a2087786', component.options)
    } else {
      api.reload('a2087786', component.options)
    }
    module.hot.accept("./UsedPartsInfoListSideMenu.vue?vue&type=template&id=a2087786&scoped=true", function () {
      api.rerender('a2087786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/usedpartsinfo/UsedPartsInfoListSideMenu.vue"
export default component.exports